/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import FileLinkView from '../FileLinkView';

import './NoteEntryView.css';
import tmplNoteEntryView from './NoteEntryView.hbs';

const NoteEntryView = View.extend({
  template: tmplNoteEntryView,

  className: 'note-entry-view panel panel-default panel-row-view',

  ui: {
    fileLinkViewContainer: '.file-link-container',
    noteContainer: '.note-container'
  },

  regions: {
    fileLinkViewContainer: '@ui.fileLinkViewContainer'
  },

  onRender() {
    if (this.model.get('fileName')) {
      this.showChildView('fileLinkViewContainer', new FileLinkView({ model: this.model }));
    } else if (this.model.get('memo')) {
      const memo = this.model.get('memo').replace(/\n/g, '<br />');
      this.ui.noteContainer.append(memo);
    }
  }
});

export default NoteEntryView;
